<template>
    <div class="columns">
        <div class="column">
            <div class="tabs is-centered">
                <ul>
                    <li v-for="tab in getAllTabs"><a @click="setActiveTab(tab)" :class="{'is-active' : tab.status }">{{ tab.name }}</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
           getAllTabs(){
               if (this.$store.getters.getUserRole === 'Sales Staff') {
                   return this.$store.getters.getAllUserTabs.filter(tab => {
                       return tab.id == 'credit' || tab.id == 'other' ? false : true;
                   });

               }
               return this.$store.getters.getAllUserTabs
           }
        },
        methods: {
            setActiveTab(tab){
                this.$store.dispatch('setActiveUserTab', tab.id)

                if (tab.link !== null) {
                    this.$router.push({name: tab.link, params: {id: this.$route.params.id}})
                }

                if (tab.link === null && this.$route.name === 'UserOther') {
                    this.$router.push({name: 'EditUser', params: {id: this.$route.params.id}})
                }

            }
        }
    }
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/UserSideBar.vue